import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth";

import api from "assets/services/api";


function ModalChangeOperation(props) {

    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const { storageId } = useAuth();

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };


    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleChangeOperation(e) {
        e.preventDefault();
        const response = await api.put('/sell/change/storage/from/'+storageId, {
            nf: props.props.nf,
            validated: props.props.validated
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.loadSell();
        props.loadTotal();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Mudar venda
          </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleChangeOperation}>
                <Modal.Body>
                    <h4> Tem certeza que deseja mudar essa venda para a operação {storageId === 1 ? "do Distrito Federal" : "de Goias"}?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit" >
                            Mudar
          </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Venda modificada para outra operação com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalChangeOperation;